import React, { useEffect, useState, useRef } from "react";
import { NavLink, withRouter } from "react-router-dom";
import RiveComponent from "../Shared/RiveComponent";

const NAV_ITEMS = [
    { key: "casino", to: "/", exact: true, icon: "content/images/bottom-nav/ico2-casino.png", label: "Casino", isActive: (match, loc) => loc.pathname === '/' || loc.pathname.startsWith('/game/') },
    { key: "promocije", to: "/promotions", icon: "content/images/bottom-nav/ico-promocije.png", label: "Promocije" },
    { key: "pretrazi", action: "search", icon: "content/images/bottom-nav/ico-pretrazi.png", label: "Pretraži" },
    { key: "poker", to: "/poker", icon: "content/images/bottom-nav/ico-poker.png", label: "Poker" },
    { key: "sport", href: "https://m.supersport.hr/", icon: "content/images/bottom-nav/ico-sport.png", label: "Sport" },
    { key: "vise", action: "more", icon: "content/images/bottom-nav/ico-vise.png", label: "Više" }
];

const POKER_NAV_ITEMS = [
    { key: "poker", to: "/poker", exact: true, icon: "content/images/bottom-nav/ico-poker.png", label: "Poker", isActive: (match, loc) => loc.pathname === '/poker' },
    { key: "promocije", to: "/poker/promotions", icon: "content/images/bottom-nav/ico-promocije.png", label: "Promocije" },
    { key: "turniri", to: "/poker/tournaments", icon: "content/images/bottom-nav/ico-turniri.png", label: "Turniri" },
    { key: "casino", to: "/", exact: true, icon: "content/images/bottom-nav/ico2-casino.png", label: "Casino" },
    { key: "sport", href: "https://www.supersport.hr/sport", icon: "content/images/bottom-nav/ico-sport.png", label: "Sport" },
    { key: "vise", action: "more", icon: "content/images/bottom-nav/ico-vise.png", label: "Više" }
];

function toDarkIcon(icon) {
    return icon.replace('.png', '-white.png');
}

function BottomNavigationBarComponent(props) {
    var [, setThemeVersion] = useState(0);
    var lastSearchClickRef = useRef(0);
    useEffect(() => {
        var handler = () => setThemeVersion(v => v + 1);
        window.addEventListener("casinoThemeChange", handler);
        return () => window.removeEventListener("casinoThemeChange", handler);
    }, []);

    if (casino.config.fromNativeApp) return null;

    var isPokerPath = props.location.pathname.startsWith('/poker');
    var isDark = !isPokerPath && casino.utils.getCasinoTheme() === "dark";

    function resolveIcon(icon) {
        return isDark ? toDarkIcon(icon) : icon;
    }

    function getActiveIcon(icon) {
        return resolveIcon(icon).replace('.png', '-active.png');
    }

    function handleSearchClick(e) {
        e.preventDefault();
        // Throttle: ignoriraj rapid klikove (<350 ms)
        var now = Date.now();
        if (now - lastSearchClickRef.current < 350) return;
        lastSearchClickRef.current = now;

        if (props.showMoreMenu) {
            props.toggleMoreMenuFn(false);
        }
        props.showSearchFn(!props.showSearch);
    }

    function handleMoreClick(e) {
        e.preventDefault();
        if (props.showSearch) {
            props.showSearchFn(false);
        }
        props.toggleMoreMenuFn(!props.showMoreMenu);
    }

    function renderItem(item) {
        if (item.action) {
            var isActive = item.action === "search" ? props.showSearch : props.showMoreMenu;
            var handler = item.action === "search" ? handleSearchClick : handleMoreClick;
            return (
                <a
                    key={item.key}
                    href="#"
                    className={"bottom-nav-tab" + (isActive ? " active" : "")}
                    onClick={handler}
                >
                    <div className="bottom-nav-icon">
                        <img src={isActive ? getActiveIcon(item.icon) : resolveIcon(item.icon)} alt={item.label} />
                    </div>
                    <span className="bottom-nav-label">{item.label}</span>
                </a>
            );
        }

        if (item.href) {
            return (
                <a
                    key={item.key}
                    href={item.href}
                    className="bottom-nav-tab"
                    onClick={() => { props.toggleMoreMenuFn(false); props.showSearchFn(false); }}
                >
                    <div className={"bottom-nav-icon" + (item.key === "sport" ? " bottom-nav-icon--sport" : "")}>
                        {item.key === "sport" ? (
                            <div className="bottom-nav-rive-wrapper">
                                <img className="bottom-nav-rive-fallback"
                                    src={resolveIcon("content/images/bottom-nav/ico-sport.png")}
                                    alt="Sport" />
                                <RiveComponent key={isDark ? "sport-dark" : "sport-light"} src={isDark ? "content/images/bottom-nav/lopta_tabbar-dark.riv" : "content/images/bottom-nav/lopta_tabbar-light.riv"} 
                                    lazyLoad={false} 
                                    useOffscreenRenderer={true}
                                    cacheBust={`c=${casino.config.guiCacheVerzija}`} 
                                    playRequest={true}
                                    height={180}
                                    width={180}
                                    className="bottom-nav-rive-animation" />
                            </div>
                        ) : (
                            <img src={resolveIcon(item.icon)} alt={item.label} />
                        )}
                    </div>
                    <span className="bottom-nav-label">{item.label}</span>
                </a>
            );
        }

        var isNavActive = !props.showSearch && !props.showMoreMenu && (item.isActive
            ? item.isActive(null, props.location)
            : props.location.pathname === item.to);

        return (
            <NavLink
                key={item.key}
                to={item.to}
                exact={item.exact || false}
                className={"bottom-nav-tab" + (isNavActive ? " active" : "")}
                isActive={() => isNavActive}
                onClick={() => { props.toggleMoreMenuFn(false); props.showSearchFn(false); }}
            >
                <div className="bottom-nav-icon">
                    <img src={isNavActive ? getActiveIcon(item.icon) : resolveIcon(item.icon)} alt={item.label} />
                </div>
                <span className="bottom-nav-label">{item.label}</span>
            </NavLink>
        );
    }

    return (
        <nav className="bottom-navigation-bar tablet-hidden">
            {(props.location.pathname.startsWith('/poker') ? POKER_NAV_ITEMS : NAV_ITEMS).map(item => renderItem(item))}
        </nav>
    );
}

export const BottomNavigationBar = withRouter(BottomNavigationBarComponent);
